<template>
    <kiosk-cloning>
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full">
            <page-header>
                Cloning Targets

                <template v-slot:actions>
                    <vx-button @click.prevent="showForm()" type="button" size="lg">
                        New Target <font-awesome-icon widthAuto :icon="faCirclePlus" />
                    </vx-button>
                </template>
            </page-header>

            <page-loading v-if="loading && !list.length"></page-loading>

            <vx-box
                color="info"
                v-else-if="!loading && !list.length"
                class="flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500"
            >
                No targets yet.
                <vx-button data-test="add-button" @click.prevent="() => {}" type="button">
                    New target <font-awesome-icon widthAuto :icon="faCirclePlus" />
                </vx-button>
            </vx-box>

            <vx-table v-else-if="list.length" class="xl:grid-cols-4-auto" rowBreakpoint="xl">
                <vx-table-row isHeader>
                    <div class="xl:col-span-2">Name</div>
                    <div>Teams</div>
                </vx-table-row>

                <kiosk-cloning-target-row
                    v-for="(item, index) in list"
                    :modelValue="list[index]"
                    :key="list[index].id"
                    @edit="showForm"
                    @deleted="removeFromList"
                ></kiosk-cloning-target-row>
            </vx-table>

            <div v-if="list.length" class="mt-8 flex justify-between w-full gap-10">
                <vx-button
                    v-if="fetchParams.cursor"
                    @click="loadData()"
                    color="muted-dark"
                    size="xl"
                    class="grow-0"
                    :loading="loading"
                    data-test="load-more-btn"
                >
                    Load More
                    <font-awesome-icon widthAuto :icon="faSpinner"></font-awesome-icon>
                </vx-button>
                <div class="text-lg grow-0 ml-auto font-normal text-slate-600">{{ list.length }}/{{ totalCount }}</div>
            </div>
            <kiosk-cloning-target-form-modal v-model="selectedTarget" @saved="targetCreatedOrUpdated" />
        </div>
    </kiosk-cloning>
</template>
<script setup>
import KioskCloning from '../KioskCloning.vue';
import { adminCloningTargetsClient } from '~/services';
import PageHeader from '~/components/general/PageHeader.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import { VxButton, VxBox, VxTable, VxTableRow } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCirclePlus, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import KioskCloningTargetRow from './KioskCloningTargetRow.vue';
import KioskCloningTargetFormModal from './KioskCloningTargetFormModal.vue';
import { useCursorPagination } from '~/composables/useCursorPagination';
import { useToasted } from '~/composables/useToasted';
import { ref } from 'vue';

const toasted = useToasted();

const { list, loading, fetchParams, fetchRecords } = useCursorPagination();
const totalCount = ref(0);

fetchParams.value = {
    per_page: 10,
    sort_dir: 'desc',
    cursor: undefined,
};

const loadData = () => {
    fetchRecords(adminCloningTargetsClient.getCloningTargets({ ...fetchParams.value }));
    fetchTotalCount();
};

const fetchTotalCount = async () => {
    try {
        const response = await adminCloningTargetsClient.getCloningTargetsCount();
        totalCount.value = response.data?.count || 0;
    } catch (e) {
        console.error(e);
        toasted.global.platform_error();
    }
};

loadData();

const removeFromList = (id) => {
    list.value = list.value.filter((item) => item.id !== id);
    totalCount.value = totalCount.value - 1;

    if (!list.value.length) {
        loadData();
    }
};

const selectedTarget = ref(null);
const showForm = (item = null) => {
    selectedTarget.value = item
        ? { ...item }
        : {
              name: '',
              teams: [],
          };
};

const targetCreatedOrUpdated = (data) => {
    const exists = list.value.findIndex((t) => t.id === data.id);
    if (exists === -1) {
        list.value = [{ ...data }, ...list.value];
        totalCount.value = totalCount.value + 1;
    } else {
        list.value = list.value.map((item) => {
            if (item.id === data.id) {
                return {
                    ...item,
                    ...data,
                };
            }

            return item;
        });
    }
};
</script>
